import { dataHandle } from '../../../services/data-handle.js';
import { MessageBox } from 'mint-ui';
export default {
    props: {
        quickQsList: Array,
        queuing: {
            type: [String, Number],
            default: 0
        }
    },
    data() {
        return {
            
        }
    },
    methods: {
        /**
         * 选择快捷问题类型
         *
         * @param { Object } item ==> 当前选择的list
         */
        selectQa(item) {
            let list = {
                menu: {
                    head_content: `“${item.head_content}”的问题有：`,
                    list: item.list,
                },
                type: "hot",
                sender: 'bot',
                msgId: dataHandle.getUid(),
                date: Date.now()
            }
            this.$parent.pushList(list);
            this.$parent.scrollBottom();
        },
        /**
         * 退出人工
         * */
        exitCS(){
            const that = this;
            MessageBox.confirm('确定退出人工客服？').then(action => {
                that.$parent.exitCS();
            }).catch(()=>{
                
            })
        }
    },
}


// WEBPACK FOOTER //
// ./src/pages/webot/quick-qs/_quick-qs.js